import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CamaraVideo = (props) => {
  const navigat = useNavigate();
  const { id, grp, sheet, workId } = useParams();

  const videoRef = useRef(null);
  const photoRef = useRef(null);

  const [size, setSize] = useState({});
  const [streamvideo, setStreamvideo] = useState();
  const [hasPhoto, setHasPhoto] = useState(false);
  const [urlImage, setUrlImage] = useState();
  const [imgcap, setImgcap] = useState();

  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: { width: 360, height: 640 } })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch((err) => {
        // console.error(err);
        alert(err);
      });
  };

  async function getMedia(constraints) {
    let stream = null;

    try {
      stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (videoRef.current) {
        let video = videoRef.current;
        setStreamvideo(stream);
        video.srcObject = stream;
        video.onloadedmetadata = () => {
          video.play();
        };
      }
    } catch (err) {
      console.error(err);
      // throw err;
    }
  }

  const takePhoto = () => {
    console.log(document.getElementById("box-camera"));
    document.getElementById("box-camera").style.display = "none";
    document.getElementById("box-result").style.display = "flex";
    let video = videoRef.current;
    let photo = photoRef.current;
    // let width = size.width;
    // let height = size.height;
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const videoWidth = video.width;
    const videoHeight = video.height;
    let canvasWidth, canvasHeight;
    // console.log('เท่าไหร่ว่ามาก่อน กว้าง',videoWidth,"\nเท่าไหร่ว่ามาก่อน สูง",videoHeight)

    if (videoWidth <= windowWidth && videoHeight <= windowHeight) {
      canvasWidth = videoWidth;
      canvasHeight = videoHeight;
    } else {
      const aspectRatio = videoWidth / videoHeight;
      if (aspectRatio >= windowWidth / windowHeight) {
        canvasWidth = windowWidth;
        canvasHeight = windowWidth / aspectRatio;
      } else {
        canvasHeight = windowHeight;
        canvasWidth = windowHeight * aspectRatio;
      }
    }
    // console.log('เท่าไหร่ว่ามา กว้าง',canvasWidth,"\nเท่าไหร่ว่ามา สูง",canvasHeight)
    photo.width = canvasWidth;
    photo.height = canvasHeight;

    let ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, canvasWidth, canvasHeight);
    setUrlImage(photo.toDataURL("image/jpeg", 1.0));
    setHasPhoto(true);
  };

  const closePhoto = () => {
    document.getElementById("box-result").style.display = "none";
    document.getElementById("box-camera").style.display = "block";
    let photo = photoRef.current;
    let ctx = photo.getContext("2d");

    ctx.clearRect(0, 0, photo.width, photo.height);

    setHasPhoto(false);
  };

  const confirm = () => {
    let stream = videoRef.current.srcObject;
    let tracks = stream.getTracks();

    tracks.forEach((tracks) => {
      console.log("omg stop please");
      tracks.stop();
    });

    videoRef.current.srcObject = null;
    // console.log("urlImage is >>", urlImage);
    if (props.Imageresult[0]) {
      let dataimage = props.Imageresult;
      props.resultImage([...dataimage, urlImage]);
    } else {
      props.resultImage([urlImage]);
    }
    stopCamera();
    navigat(`/assessment/${id}/${grp}/${sheet}/${workId}`);
  };

  const checkscreen = () => {
    if (window.innerWidth > window.innerHeight) {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      getMedia({
        audio: false,
        video: {
          facingMode: "environment",
          width: { ideal: window.innerWidth },
          // height: { ideal: window.innerHeight },
          zoom: { ideal: 1.0 },
          ptz: false,
          pan: 3600,
          video: true,
          audio: false,
        },
      });
    } else {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      getMedia({
        audio: false,
        video: {
          facingMode: "environment",
          height: { ideal: window.innerHeight},
          // width: { ideal: window.innerWidth },
          zoom: { ideal: 1.0 },
          ptz: false,
          pan: 3600,
          video: true,
          audio: false,
        },
      });
    }
  };

  const stopCamera = () => {
    if (streamvideo) {
      try {
        // console.log("มีการ streamvideo srcObject");
        const tracks = streamvideo.getTracks();
        tracks.forEach((track) => track.stop());
        let videoElement = document.getElementById("box-camera");
        videoElement.style.visibility = "hidden";

        videoRef.current.srcObject = null;
        setStreamvideo(null);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const initialOrientation = window.orientation;

  window.onorientationchange = () => {
    const newOrientation = window.orientation;
    if (newOrientation !== initialOrientation) {
      // stopCamera();
      setTimeout(() => {
        checkscreen();
      }, 100);
      console.log("มีหมุนแนวนอน");
    } else {
      // stopCamera();
      setTimeout(() => {
        checkscreen();
      }, 100);
      console.log("มีหมุนแนวตั้ง");
    }
  };

  // useEffect(() => {
  //   getMedia({
  //     audio: false,
  //     video: {
  //       video: true,
  //       facingMode: "environment",
  //       width: size.width,
  //       height: size.height,
  //     },
  //   });
  // }, [videoRef]);
  useEffect(() => {
    checkscreen();
  }, []);

  // useEffect(() => {
  //   if (!size.width) return;
  //   console.log(size);
  //   document.getElementById("box-camera").style.width = `${size.width}px`;
  //   document.getElementById("box-camera").style.height = `${size.height}px`;
  // }, [size]);

  return (
    <div className="camara-video">
      <div className="camera" id={"box-camera"}>
        <video
          className="video-camera"
          ref={videoRef}
          id="videoCameraId"
          width={window.innerWidth}
          height={window.innerHeight}
        ></video>
      </div>
      <button
        className="btn-back-off"
        onClick={() => {
          stopCamera();
          navigat(`/assessment/${id}/${grp}/${sheet}/${workId}`);
        }}
      >
        <Icon icon="icon-park-solid:back" />
      </button>
      <button
        className={
          parseInt(size.height) >= 640 ? "btn-takePhoto" : "btn-takePhoto-h"
        }
        onClick={takePhoto}
      >
        <i className="bi-camera-fill"></i>
      </button>
      <div
        className={"result" + (hasPhoto ? "hasPhtoto" : "")}
        id={"box-result"}
      >
        <canvas
          ref={photoRef}
          className="canvas-img-show"
          style={{ margin: "auto" }}
        ></canvas>
        <img src={urlImage}></img>
        <button
          className={size.height === 640 ? "btn-close" : "btn-close-h"}
          onClick={closePhoto}
        >
          <i className="bi-x-lg"></i>
        </button>
        <button
          className={size.height === 640 ? "btn-confrim" : "btn-confrim-h"}
          onClick={confirm}
        >
          <i className="bi-check"></i>
        </button>
      </div>
    </div>
  );
};

// function useWindowSize() {
//   const [windowSize, setWindowSize] = useState({
//     width: undefined,
//     height: undefined,
//   });

//   useEffect(() => {
//     function handleResize() {
//       //   alert(`size ${window.innerWidth} ${window.innerHeight}`);
//       // console.log(
//       //   "size hight",
//       //   window.innerHeight,
//       //   "\nsize width",
//       //   window.innerWidth
//       // );
//       if (window.innerWidth > window.innerHeight) {
//         setWindowSize({
//           width: window.innerWidth,
//           height: window.innerHeight,
//         });
//         getMedia({
//           audio: false,
//           video: {
//             facingMode: "environment",
//             width: { ideal: window.innerWidth },
//             zoom: { ideal: 1.0 },
//             ptz: false,
//             pan: 3600,
//             video: true,
//           },
//         });
//       } else {
//         setWindowSize({
//           width: window.innerWidth,
//           height: window.innerHeight,
//         });
//         getMedia({
//           audio: false,
//           video: {
//             facingMode: "environment",
//             height: { ideal: window.innerHeight },
//             zoom: { ideal: 1.0 },
//             ptz: false,
//             pan: 3600,
//             video: true,
//           },
//         });
//       }
//     }
//     window.addEventListener("resize", handleResize);
//     handleResize();
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return windowSize;
// }

export default CamaraVideo;
